import { apiV2Root } from "consts";
import type { ContentUrlCheck } from "features/pages/usePageContentCheck";
import { useDataQueryParams } from "hooks/useDataQueryParams";

export const useEventRegistrationContentCheck = (
  eventId: number | undefined,
): ContentUrlCheck | undefined =>
  useDataQueryParams<ContentUrlCheck>(
    `events/${eventId}/registration/content-check/`,
    {},
    apiV2Root,
    !eventId,
  );
